import { IPromoPriceProperties } from '@vfde-brix/ws10/promo-price';
import { Price } from '@vfde-brix/ws10/core';
import { getPriceWithRegioCharge } from '../regioCharge';
import { JarvisProduct } from '@vfde-sails/avc-core';
import { SummaryCardPriceLabel } from './summaryCardHelper';

const CONDITION_BEFORE = 'ab';

export const getTariffPriceProps = (
    { discount, price }: JarvisProduct,
    isFriendsAndFamily: boolean,
    regioCharge?: number
): Partial<IPromoPriceProperties> => {
    // apply discount
    const isStairwayPrice = 0 !== discount.gross;
    const isOncePrice = 'number' === typeof price.once;
    // apply regio charge
    const priceNumber = getPriceWithRegioCharge(
        isStairwayPrice ? discount.gross : +price.monthly,
        regioCharge,
    );

    return {
        price: isFriendsAndFamily
            ? Price.fromString((priceNumber - 5).toFixed(2))
            : Price.fromNumber(+priceNumber.toFixed(2)),
        strikePrice: isFriendsAndFamily
            ? Price.fromString(priceNumber.toFixed(2).toString())
            : undefined,
        optPriceConditionBefore: isOncePrice ? CONDITION_BEFORE : '',
        stdConditionAfter: isOncePrice ? SummaryCardPriceLabel.Once : SummaryCardPriceLabel.Monthly,
    };
};
